import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import type { ModuloWeb } from '../../nucleo/modulos';
import { dicionario } from './i18n';

const carregar0 = () => import('./Resumo');
const carregar1 = () => import('./Compromisso');
const carregar2 = () => import('./Decisoes');
const carregar3 = () => import('./Fontes');

const ResumoSala = telaSobDemanda(carregar0, 'ResumoSala');
const CompromissoPagina = telaSobDemanda(carregar1, 'CompromissoPagina');
const EvidenciasPagina = telaSobDemanda(carregar1, 'EvidenciasPagina');
const AcaoDecisoes = acaoSobDemanda(carregar2, 'AcaoDecisoes');
const DecisaoPagina = telaSobDemanda(carregar2, 'DecisaoPagina');
const FilaDecisoes = telaSobDemanda(carregar2, 'FilaDecisoes');
const FontesPagina = telaSobDemanda(carregar3, 'FontesPagina');

export const modulo: ModuloWeb = {
  slug: 'sala360',
  menu: 'sala360',
  dicionario,
  abas: [
    { rotulo: 'abas.resumo', caminho: 'resumo', elemento: <ResumoSala />, ordem: 1 },
    { rotulo: 'abas.decisoes', caminho: 'decisoes', elemento: <FilaDecisoes />, Acao: AcaoDecisoes, ordem: 2 },
    { rotulo: 'abas.fontes', caminho: 'fontes', elemento: <FontesPagina />, ordem: 3 },
  ],
  rotas: [
    { path: 'sala360/compromisso/:origem/:id', element: <CompromissoPagina /> },
    { path: 'sala360/compromisso/:origem/:id/evidencias', element: <EvidenciasPagina /> },
    { path: 'sala360/decisao/:id', element: <DecisaoPagina /> },
  ],
};
